let user = JSON.parse(window.localStorage.getItem('user'))
/*
* 不许改动这个文件
*/
const host = window.location.host;
let clientId = 100131;
let brandId = 570678343;
let http = 'https://eapi.my.ciwong.com';
let httpApp = 'https://m.teacher.jiaofuyun.com';

// if (host == 'xi.my.prev.ciwong.com') {
//     http = 'https://eapi.my.prev.ciwong.com';
//     httpApp = 'https://prevm.teacher.jiaofuyun.com'
// } else if (host == 'xi.my.ciwong.com') {
//     http = 'https://eapi.my.ciwong.com';
//     httpApp = 'https://m.teacher.jiaofuyun.com'
// } else {
//     brandId = 524726977
// }

// http = 'http://eapi.my.prev.ciwong.com';
// brandId = 570678343;
export {clientId, brandId, http, schoolId, httpApp}



// WEBPACK FOOTER //
// ./src/config.js